module.exports = __webpack_public_path__ + "static/media/events-add-operational-risk-business.069807b0.svg";